import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullUnauthedBusiness from "../fragments/fullUnauthedBusinessV4"

export const unAuthedBusiness = gql`
  query UnAuthedBusiness($businessId: ID!) {
    unAuthedBusiness(businessId: $businessId) {
      ...fullUnauthedBusiness
    }
  }
  ${fullUnauthedBusiness}
`

export const unAuthedBusinessKey = getQueryNames(unAuthedBusiness)[0]
